import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * About 70 screens open a toast with `error.error.message` after a failed
 * request. When the API sends no `message` (validation errors, 404, network
 * failure) that toast is empty, and it replaces the readable one the HTTP
 * interceptor already showed for the same error.
 *
 * Skipping toasts without text fixes every one of those call sites at once:
 * the interceptor's message stays on screen.
 */
const originalOpen = MatSnackBar.prototype.open;

MatSnackBar.prototype.open = function (this: MatSnackBar, message: any, action?: string, config?: any) {
  const text = message == null ? '' : String(message).trim();
  if (!text || text === 'undefined' || text === 'null') {
    return undefined as any;
  }
  return originalOpen.call(this, text, action, config);
} as typeof MatSnackBar.prototype.open;
